export default __webpack_public_path__ + "static/media/remax.07db3367.png";